import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import ListGroup from 'react-bootstrap/ListGroup'
import Page from '../../component/page'
import { isAdmin } from './isAdmin'

export { isAdmin }

const sections = [
  {
    title: 'Course management',
    links: [
      { label: 'Course Manager', to: '/admin/courses/manage', internal: true },
      { label: 'Course Curation', to: '/admin/curation', internal: true },
      { label: 'Edit Monitor', to: '/admin/edits', internal: true },
    ],
  },
  {
    title: 'API — Swagger',
    links: [
      {
        label: 'Production',
        href: 'https://discgolfapi.codeunlimited.se/swagger-ui/index.html',
      },
      {
        label: 'Test',
        href: 'https://discgolfapi-test.codeunlimited.se/swagger-ui/index.html',
      },
    ],
  },
  {
    title: 'CI — Jenkins',
    links: [
      {
        label: 'Android',
        href: 'https://jenkins.codeunlimited.se/job/discgolf-android/',
      },
      {
        label: 'Server',
        href: 'https://jenkins.codeunlimited.se/job/discgolf-server/',
      },
      {
        label: 'Web',
        href: 'https://jenkins.codeunlimited.se/job/discgolf-web/',
      },
    ],
  },
  {
    title: 'Source — GitHub',
    links: [
      { label: 'Android', href: 'https://github.com/ptornhult/discgolf-android' },
      { label: 'Server', href: 'https://github.com/ptornhult/discgolf-server' },
      { label: 'Web', href: 'https://github.com/ptornhult/discgolf-web' },
    ],
  },
  {
    title: 'Monitoring',
    links: [{ label: 'Grafana', href: 'https://grafana.codeunlimited.se/' }],
  },
  {
    title: 'External',
    links: [
      { label: 'Facebook page', href: 'https://www.facebook.com/discgolfapp' },
      { label: 'Sonatype guide', href: 'https://guide.sonatype.com/' },
    ],
  },
]

const renderLink = (link) => {
  if (link.internal) {
    return (
      <ListGroup.Item key={link.to} action as={Link} to={link.to}>
        {link.label}
      </ListGroup.Item>
    )
  }
  return (
    <ListGroup.Item
      key={link.href}
      action
      href={link.href}
      target="_blank"
      rel="noreferrer"
    >
      {link.label} <i className="bi-box-arrow-up-right"></i>
    </ListGroup.Item>
  )
}

function Dashboard({ user }) {
  if (!isAdmin(user)) return null

  return (
    <Page className="container admin dashboard" hideAds>
      <div className="row">
        <div className="col-sm-12">
          <h1>Admin</h1>
          <Row xs={1} md={2} lg={3} className="g-3">
            {sections.map((section) => (
              <Col key={section.title}>
                <Card>
                  <Card.Header>{section.title}</Card.Header>
                  <ListGroup variant="flush">
                    {section.links.map(renderLink)}
                  </ListGroup>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </Page>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
})

export default connect(mapStateToProps)(Dashboard)
